"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.status.pending': 'Pending',
    'onboarding.status.in_progress': 'In Progress',
    'onboarding.status.completed': 'Completed',
    'onboarding.status.all': 'All Statuses',
    'onboarding.status.abandoned': 'Abandoned',
    'onboarding.status.unknown': 'Unknown',
};
